export const PersonalSettingsRoutes = {
  path: '/personal-settings',
  lazy: () => import('pages/personal-settings/PersonalSettings.page'),
};
